import { ComponentFields, Field, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

import { LearningTypes } from 'src/enums/LearningTypes';

import { ContentDetailItem } from 'src/types/ContentDetailsItem';
import { ExtendedItem } from 'src/types/ExtendedItem';
import { ResourceListItem } from 'src/types/ResourceListItem';

import { parseAccessLevelRouteFields } from '../fields/parseAccessLevelContent';
import { parseAccessTypes, parseAccessTypesString } from '../fields/parseAccessTypes';
import { parseIsoDate } from '../fields/parseDate';
import { parseTags } from '../fields/parseTags';
import { parseTypesOfResources, parseTypesOfResourcesString } from '../fields/parseTypesOfResources';
import { parseWildCardUrl } from '../fields/parseUrl';

export function mapResourcePage(item: ExtendedItem, wildcardUrl?: string): ResourceListItem | null {
	try {
		if (!item) {
			return null;
		}

		return {
			Id: item.id,
			Title: (item.fields.PageTitle as Field<string>).value,
			Strapline: (item.fields.Strapline as Field<string>)?.value,
			Url: parseWildCardUrl(item.name, wildcardUrl),
			LearningType: LearningTypes.Resource.toString(),
			AccessTypes: parseAccessTypes(item.fields.AccessType),
			AccessTypesString: parseAccessTypesString(item.fields.AccessType),
			TypesOfResources: parseTypesOfResources(item.fields.Tags),
			TypesOfResourcesString: parseTypesOfResourcesString(item.fields.Tags),
			ImageUrl: item.fields.PageImage ? (item.fields.PageImage as ImageField).value?.src : '',
			Tags: parseTags(item.fields.Tags),
		};
	} catch (error) {
		console.error(error);
		return null;
	}
}

export function mapResourcePageToContentDetails(
	id: string,
	fields: ComponentFields | undefined,
	wildcardContentUrl: string | undefined
): ContentDetailItem | null {
	try {
		if (!fields) {
			return null;
		}

		const dateUpdated = fields.DateUpdated ? parseIsoDate((fields.DateUpdated as Field<string>).value) : null;

		return {
			Id: id,
			Title: fields.PageTitle && (fields.PageTitle as Field<string>).value ? (fields.PageTitle as Field<string>).value : '',
			ImageUrl: fields.PageImage && (fields.PageImage as ImageField).value?.src ? (fields.PageImage as ImageField).value?.src : '',
			Tags: parseTags(fields.Tags),
			AccessTypes: parseAccessTypes(fields.AccessType),
			AccessTypesString: parseAccessTypesString(fields.AccessType),
			Access: parseAccessLevelRouteFields(fields),
			TypesOfResources: parseTypesOfResources(fields.Tags),
			TypesOfResourcesString: parseTypesOfResourcesString(fields.Tags),
			DateUpdated: dateUpdated,
			Information: '',
			IsCpdArticle: false,
			IsLmsModule: false,
			IsLmsCourse: false,
			IsResource: true,
			PeerReviewed: fields.PeerReviewed && (fields.PeerReviewed as Field<boolean>).value === true,
			LearningTypeString: LearningTypes.Resource.toString(),
			LearningType: LearningTypes.Resource,
			CertificateOfCompletion: false,
			ProfessionalLeads: undefined,
			Url: wildcardContentUrl,
			Cost: undefined,
			Location: '',
			ShowAdvisoryContent: fields.ShowAdvisoryContent && (fields.ShowAdvisoryContent as Field<boolean>).value === true,
			AdvisoryContentText:
				fields.AdvisoryContentText && (fields.AdvisoryContentText as Field<string>).value
					? (fields.AdvisoryContentText as Field<string>).value
					: '',
		};
	} catch (error) {
		console.error(error);
		return null;
	}
}
